import { render, staticRenderFns } from "./Organization.vue?vue&type=template&id=1cf22488&scoped=true&"
import script from "./Organization.vue?vue&type=script&lang=ts&"
export * from "./Organization.vue?vue&type=script&lang=ts&"
import style0 from "./Organization.vue?vue&type=style&index=0&id=1cf22488&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf22488",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1cf22488')) {
      api.createRecord('1cf22488', component.options)
    } else {
      api.reload('1cf22488', component.options)
    }
    module.hot.accept("./Organization.vue?vue&type=template&id=1cf22488&scoped=true&", function () {
      api.rerender('1cf22488', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/Organization.vue"
export default component.exports